<template>
  <kst-section items-mode>
    <kst-table input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="InvItemCatalog.DispatchID.ColumnLabel"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.Details.getItemInfo(details, row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="InvItemCatalog.Packaging.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="RequestedQuantity"
        :label="InvItemCatalog.RequestedQuantity.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="InvItemCatalog.SellPrice.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>

      <template v-if="details.SpecialPriceCount > 0">
        <b-table-column
          v-slot="{ column, row }"
          cell-class="ks-col-specialpricename"
          field="SpecialPriceID"
          :label="InvItemCatalog.SpecialPriceID.Label"
        >
          <kst-output field-only
            :field="column.field" :data="row" :catalog="InvItemCatalog"
          />
        </b-table-column>
      </template>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Price"
        :label="InvItemCatalog.Price.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import InvItemCatalog from "../InvItemCatalog.js";
import Model from "../InvModel.js";

export default {
  props: {
    details: Object,
    items: Array
  },
  data: () => ({
    InvItemCatalog: InvItemCatalog,
    Model: Model
  })
}
</script>